import React from "react"
import useAllSitePage from '../../hooks/useAllSitePage'
import Button from "../../shared/Button/Button"
import ReactMarkdown from 'react-markdown';
import { useWindowSize } from '../../helpers/useWindowSize'

import "./BannerButtons.scss"

const BannerButtons = ({
  content, bannerButtons, imageFilter, imageMobile, backgroundImage
}) => {
  const pagesPath = useAllSitePage()
  const [width] = useWindowSize()
  const {
    allSitePage: matchPages
  } = pagesPath
  
  return (
    <div
      className={`${backgroundImage && "mb-5"} banner-buttons-container`}
      style={{
        height: '100%',
        minHeight: '70vh',
        backgroundImage:
          (width <= 576 && imageMobile) ? `url(${imageMobile?.url})` :
            backgroundImage?.url
              ? `url(${backgroundImage.url})`
              : '',
        backgroundRepeatY: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center'
      }}
    >
      <div className={`info-container ${imageFilter && "background-filter"} p-5`}>
        {content &&
          <div>
            <ReactMarkdown
              children={content}
              className="content-container"
            />
          </div>
        }
        <div className="buttons-container">
          {bannerButtons && bannerButtons.map((button, index) => (
            <div className="m-2" key={`button-${index}`}>
              <Button
                key={`banner-button-${index}`}
                button={{ label: button.content, ...button }}
                customButton={{ variant: 'light_outline', size: "big", shape: 'rectangle' }}
                classContainer="d-flex"
                matchPages={matchPages?.nodes}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default BannerButtons
